import { render, staticRenderFns } from "./CommoditySetting.vue?vue&type=template&id=45b15488&"
import script from "./CommoditySetting.vue?vue&type=script&lang=js&"
export * from "./CommoditySetting.vue?vue&type=script&lang=js&"
import style0 from "./CommoditySetting.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports